import { rowsOfGround } from '../../world/banks.js';
/** Hand-built camp, independent of the generated valley and its manual edits. */
export function buildTutorial(arrive) {
    const width = 40;
    const height = 32;
    const ground = Array.from({ length: height }, (_, y) => Array.from({ length: width }, (_, x) => {
        if (x < 2 || y < 2 || x >= width - 2 || y >= height - 2)
            return 'w';
        // The camp's square, the road east to the arch, and the yard before
        // the forge and the foundry, north of the road.
        if ((x >= 7 && x <= 19 && y >= 13 && y <= 20) ||
            (y >= 16 && y <= 18 && x >= 5 && x <= 35) ||
            (y >= 13 && y <= 15 && x >= 19 && x <= 33))
            return 'd';
        return '.';
    }).join(''));
    return {
        id: 'tutorial',
        name: 'Camp des premiers pas',
        width,
        height,
        spawn: { x: 10, y: 18 },
        rows: rowsOfGround(ground),
        ground,
        biomes: Array.from({ length: height }, () => '0'.repeat(width)),
        props: [
            { prop: 'shop', x: 12, y: 11 },
            { prop: 'stall', x: 17, y: 14 },
            { prop: 'well', x: 7, y: 14 },
            { prop: 'oak', x: 5, y: 8 },
            // The smith's forge and the smelter's foundry, side by side north of
            // the road: the two lessons after the merchant's (ADR 0030).
            { prop: 'forge', x: 22, y: 12 },
            { prop: 'foundry', x: 30, y: 12 },
            { prop: 'oak', x: 36, y: 7 },
            { prop: 'oak', x: 35, y: 25 },
            { prop: 'oak', x: 8, y: 26 },
            { prop: 'bush', x: 14, y: 25 },
            { prop: 'flowers', x: 6, y: 20 },
            { prop: 'flowers', x: 19, y: 22 },
            { prop: 'portal', x: 35, y: 15 },
        ],
        landmarks: [
            { name: 'Camp des premiers pas', x: 12, y: 16, radius: 10, kind: 'village' },
            { name: 'Terrain d’entraînement', x: 27, y: 23, radius: 6, kind: 'place' },
            { name: 'Vers Havrebourg', x: 35, y: 16, radius: 2, kind: 'place' },
        ],
        spawns: [
            // Beside the spawn, facing the camera, on his pegasus.
            { mob: 'tutor', x: 12, y: 18 },
            { mob: 'merchant', x: 17, y: 15 },
            { mob: 'smith', x: 24, y: 13 },
            { mob: 'smelter', x: 30, y: 13 },
            { mob: 'rat', x: 25, y: 23, personal: true },
            { mob: 'rat', x: 30, y: 25, personal: true },
            { mob: 'rat', x: 29, y: 20, personal: true },
        ],
        exits: [{ x: 34, y: 16, width: 3, to: 'world', arrive }],
    };
}
//# sourceMappingURL=tutorial.js.map